import { Injectable } from '@angular/core';
import { Events } from '@ionic/angular';
import { AngularFirestore } from '@angular/fire/firestore';
import { map, first } from 'rxjs/operators';
import { AngularFireStorage } from '@angular/fire/storage';

@Injectable({
  providedIn: 'root'
})
export class ProductOptionsService {

  constructor(private events: Events,
              private afs: AngularFirestore,
              private fbStorage: AngularFireStorage) { }

  initializeSubscriptions() {
    this.events.subscribe('product-options:getAllProductOptions', (pid) => {
      this.getAllProductOptions(pid);
    });
    this.events.subscribe('product-options:deleteProductOption', (oid, pid) => {
      this.deleteProductOption(oid, pid);
    });
    this.events.subscribe('product-options:editProductOption', (editdata, pid, oid, listOfImages, barcode) => {
      this.editProductOption(editdata, pid, oid, listOfImages, barcode);
    });
    this.events.subscribe('product-options:getOptionData', (pid, oid) => {
      this.getOptionData(pid, oid);
    });
  }

  async getAllProductOptions(pid) {
    try {
      const optionsRef = this.afs.collection('products').doc(pid).collection('options');
      const optionsSnap = optionsRef.snapshotChanges().pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        }))
      );
      const options = await optionsSnap.pipe(first()).toPromise();
      this.events.publish('product-options:publishAllProductOptions', options);
    } catch (error) {
      console.dir(error);
    }
  }

  async deleteProductOption(oid: string, pid: string) {
    try {
      await this.afs.collection('products').doc(pid).collection('options').doc(oid).delete();
      this.events.publish('product-options:getAllProductOptions', pid);
      this.events.publish('product-options:deleteProductOptionSuccess');
    } catch (error) {
      console.dir(error);
    }
  }

  async editProductOption(editdata, pid, oid, listOfImages, barcode) {
    //// console.log('editProduct data...', editdata, listOfImages);
    let colorObj: any = {};

    if(editdata.color.hasOwnProperty('image') && editdata.color.image.includes('data:image/jpeg;base64,')) {
        colorObj = {...editdata.color};
        delete editdata.color.image;
    }
    if(barcode !== '') {
      const imgRef: any = this.fbStorage.ref(`productOptions/${pid}/options/${oid}/barcode/` + new Date().getTime().toString() + '.png');
      await imgRef.putString(barcode, 'data_url');
      const downloadURL = await imgRef.getDownloadURL().pipe(first()).toPromise();
      editdata["barcode"] = downloadURL;
      await this.afs.collection('products').doc(pid).collection('options').doc(oid).update(editdata);
    } else {
      await this.afs.collection('products').doc(pid).collection('options').doc(oid).update(editdata);
    }
    if(colorObj.hasOwnProperty('image')) {
      //// console.log('colorObj', colorObj);
      const imgRef: any = this.fbStorage.ref(`productOptions/${pid}/options/${oid}/color/` + new Date().getTime().toString() + '.png');
      await imgRef.putString(colorObj.image, 'data_url');
      const downloadURL = await imgRef.getDownloadURL().pipe(first()).toPromise();
      await this.afs.collection('products').doc(pid).collection('options').doc(oid).update({
        color: {
          image: downloadURL,
          name: colorObj.name,
          code: colorObj.code
        }
      });
    }
    if(listOfImages.length !== 0) {
      try {
        await this.addimgtoFirebase(pid, oid, listOfImages);
        this.events.publish('product-options:editSuccess', 'Success', 'Product edited successfully!');
      } catch (error) {
        //// console.log(error);
        this.events.publish('product-options:editFailure', 'Failure', 'Product not edited successfully!');
      }
    } else if(!editdata.images.length && !listOfImages.length) {
      await this.afs.collection('products').doc(pid).collection('options').doc(oid).update({
        coverPic: {
          url: 'assets/img/placeholder-img.jpg',
          mob: 'assets/img/placeholder-img.jpg',
          thumb: 'assets/img/placeholder-img.jpg'
        }
      });
      this.events.publish('product-options:editSuccess', 'Success', 'Product edited successfully!');
    } 
    else {
      //// console.log('in else part');
      this.events.publish('product-options:editSuccess', 'Success', 'Product edited successfully!');
    }
  }

  async addimgtoFirebase(pid, oid, imgdataAndSize) {
    const image: any = {
      url: null,
      size: null,
      uploadedAt: null,
      productId: null,
      optionId: null
    };
    for (let i = 0; i < imgdataAndSize.length; i++) {
      image.url = '';
      image.size = imgdataAndSize[i].size;
      image.uploadedAt = new Date();
      image.productId = pid;
      image.optionId = oid;
      const mediaDocRef = await this.afs.collection('media').doc('images').collection('productOptions').add(image);
      const imgRef: any = this.fbStorage.ref(`productOptions/${pid}/options/${oid}/images/` + mediaDocRef.id + '.png');
      await imgRef.putString(imgdataAndSize[i].base64Img, 'data_url');
      if (imgdataAndSize[i].cover === true) {
        const downloadURL = await imgRef.getDownloadURL().pipe(first()).toPromise();
        this.afs.collection('products').doc(pid).collection('options').doc(oid).update({coverPic: {imageId: mediaDocRef.id, url: downloadURL}});
      }
    }
  }

  async getOptionData(pid: string, oid: string) {
    try {
      const optData = await this.afs.collection('products').doc(pid).collection('options').doc(oid).valueChanges().pipe(first()).toPromise();
      const productData: any = await this.afs.collection('products').doc(pid).valueChanges().pipe(first()).toPromise();
      this.events.publish('product-options:publishOptionData', optData, productData);
    } catch (error) {
      console.dir(error);
    }
  }
}


